export const wrapper = 'flex flex-row justify-start items-center p-4';
export const fullWrapper = 'flex flex-col justify-start items-start p-4';
export const iconWrapper =
  'h-12 w-12 mr-4 rounded-full justify-center items-center flex';
